import {
  TableBody,
  TableCell,
  TableRow
} from "@interstate/components/SimpleTable";
import {FC} from "react";
import {OrganizationAddress} from "@common-core/coat-operational-hierarchy-appsync-model";
import {useTranslation} from "react-i18next";
import "./AddressTableBody.scss";

export interface AddressTableBodyProps extends OrganizationAddress {
  id?: string;
}

export const AddressTableBody: FC<AddressTableBodyProps> = ({
  id,
  streetAddressLine1,
  streetAddressLine2,
  city,
  state,
  zip,
  country
}) => {
  const {t} = useTranslation();
  const tableBodyId = id ? `address-table-body-${id}` : "address-table-body";
  return (
    <TableBody
      id={tableBodyId}
      data-testid={tableBodyId}
      className={"address-table-body address-body"}>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.street")}
        </TableCell>
        <TableCell
          className={"address-value"}
          data-testid={"street-address-line1"}>
          {streetAddressLine1}
        </TableCell>
      </TableRow>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.streetAddressLine2")}
        </TableCell>
        <TableCell
          className={"address-value"}
          data-testid={"street-address-line2"}>
          {streetAddressLine2}
        </TableCell>
      </TableRow>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.city")}
        </TableCell>
        <TableCell className={"address-value"} data-testid={"city"}>
          {city}
        </TableCell>
      </TableRow>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.state")}
        </TableCell>
        <TableCell className={"address-value"} data-testid={"state"}>
          {state}
        </TableCell>
      </TableRow>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.zip-code")}
        </TableCell>
        <TableCell className={"address-value"} data-testid={"zip"}>
          {zip}
        </TableCell>
      </TableRow>
      <TableRow className={"address-row"}>
        <TableCell className={"address-field"}>
          {t("entity-detail.dealer.address.country")}
        </TableCell>
        <TableCell className={"address-value"} data-testid={"country"}>
          {country}
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
